function apply(converter, value) {
  return converter.filter(value) ? converter.convert(value) : value;
}
function chain(converters, initialValue) {
  return converters.reduce(
    (value, converter) => apply(converter, value),
    initialValue
  );
}
function createRegexBasedConverter(searchRegExp, replaceValue) {
  return {
    filter: (value) => searchRegExp.test(value),
    convert: (value) => value.replace(new RegExp(searchRegExp, "g"), replaceValue)
  };
}
function createDecryptingConvertor(keymap) {
  const regexp = new RegExp(`[${Object.keys(keymap).join("")}]`, "g");
  return {
    filter: (price) => regexp.test(price),
    convert: (price) => price.replace(regexp, (match) => keymap[match] || match)
  };
}
function createCurrencyRemover(currencyCode) {
  return {
    filter: (value) => value.includes(currencyCode),
    convert: (value) => value.replace(currencyCode, "")
  };
}
function currencyToReadableString(currency) {
  if (currency === "(none)") {
    return "";
  }
  return chain(
    [
      // Step 1:
      // Currencies that include '.', ',' or numerals have to explicitly be removed first.
      createCurrencyRemover("грн."),
      createCurrencyRemover("kr."),
      createCurrencyRemover("ل.ل."),
      createCurrencyRemover("د.أ."),
      createCurrencyRemover("ج.م."),
      // Step 2:
      // Convert numbers to arabic so the rest of the code doesn't remove them.
      // Burmese to western arabic numerals.
      createDecryptingConvertor({
        "၀": "0",
        "၁": "1",
        "၂": "2",
        "၃": "3",
        "၄": "4",
        "၅": "5",
        "၆": "6",
        "၇": "7",
        "၈": "8",
        "၉": "9"
      }),
      // Eastern arabic to western arabic numerals.
      createDecryptingConvertor({
        "٠": "0",
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        "٬": ",",
        "٫": ","
      }),
      // Step 3:
      // Enforce consistent usage of '.' and ',', so the rest of the code can take advantage of that.
      // Use comma of dot for digit grouping.
      // Assume digit grouping of three.
      createRegexBasedConverter(/\.(?=\d{3})/, ","),
      // Use dot of comma as decimal separator.
      // Assume two digits after decimal symbol. Remove commas with dots.
      createRegexBasedConverter(/,(?=(\d{2})(?!\d))/, "."),
      // Step 4:
      // Filter out any remaining unknown symbols (currencies not mentioned above; commas).
      {
        filter: () => true,
        convert: (price) => price.replace(/[^0-9.]/g, "")
      }
    ],
    currency
  );
}
function currencyToNumber(currency) {
  return Number(currencyToReadableString(currency));
}
export {
  currencyToNumber
};
